
    const data = {"name":"src/core/icons/calendar-text","data":{"viewBox":"0 0 24 24","data":"<path pid=\"0\" d=\"M14 14H7v2h7m5 3H5V8h14m0-5h-1V1h-2v2H8V1H6v2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2m-2 7H7v2h10v-2Z\"/>","originalColors":[],"stopColors":[]}}

            export default data
            